import React, { Component } from 'react';

import ContainersProblematicServers from './ContainersProblematicServicesComponent'
import { actions } from './ContainersProblematicServicesReducer'
import { connect } from 'react-redux'

class Wrapper extends Component {
    componentDidMount() {
        this.props.fetch();
    }

    render() {
        return (
            <React.Fragment>
                <ContainersProblematicServers {...this.props} />                
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        fetcher: state.waas.containersProblematicServices.fetcher,
        items: state.waas.containersProblematicServices.fetcher.items || []
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetch: () => dispatch(actions.trigger()),
        reload: () => dispatch(actions.trigger()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)